import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from '../../../app/core/utils';
import { nullSafe } from '../../utils';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  // roles: string[] = [];
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.hasAccess(next, state);
  }

  hasAccess(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {

    const moduleid = nullSafe(() => (typeof route.data['moduleid'] === 'string' ? route.data['moduleid'].trim() : '-'), '-');
    if (moduleid !== '-' && !this.authService.isActiveFeature(moduleid)) {
      this.router.navigate(['/denied'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    if (this.authService.isAuthenticated) {
      // const userModuleclaims = nullSafe(() => this.authService.ActiveUser.modules, []);
      // const userFeatureclaims = nullSafe(() => this.authService.ActiveUser.features, []);

      const requiredClaim = nullSafe(() => (typeof route.data['claim'] === 'string' ? route.data['claim'] : '-'), '-');

      if (isNullOrUndefined(requiredClaim) || requiredClaim === '-') {
        return true;
      }
      if (this.authService.isAuthorised(requiredClaim)) {
        return true;
      } else {
        this.router.navigate(['/denied'], { queryParams: { returnUrl: state.url } });
        return false;
      }
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // canActivateChild(
  //   next: ActivatedRouteSnapshot,
  //   state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //     return this.checkLogin();
  // }
  // canLoad(
  //   route: Route,
  //   segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
  //     return this.checkLogin();
  // }

  // private checkLogin(state: RouterStateSnapshot): boolean {
  //   if (this.authService.isAuthenticated) {
  //     if (this.checkChildren(state.root.children)) {
  //       return true;
  //     }
  //     return false;
  //   }
  //   // not logged in so redirect to login page with the return url
  //   this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
  //   return false;
  // }

  // checkHasAccess(root: ActivatedRouteSnapshot) {
  //   if (isNullOrUndefined(root.data.claim) && root.children.length > 0) {
  //     let val = this.checkChildren(root.children);
  //     return val;
  //   } else if (!isNullOrUndefined(root.data.claim) && root.children.length > 0) {
  //     this.roles.forEach(role => {
  //       if (role === root.data.claim) {
  //         return this.checkChildren(root.children);
  //       }
  //     });
  //     return false;
  //   } else if (isNullOrUndefined(root.data.claim) && root.children.length === 0) {
  //     return false;
  //   } else if (!isNullOrUndefined(root.data.claim) && root.children.length === 0) {
  //     let res1 = false;
  //     this.roles.forEach(role => {
  //       if (role === root.data.claim) {
  //         res1 = true;
  //       }
  //     });

  //     return res1;
  //   }

  // }

  // checkChildren(children: ActivatedRouteSnapshot[]) {
  //   let res2 = false;
  //   children.forEach(child => {
  //     if (isNullOrUndefined(child.data.claim) && child.children.length > 0) {
  //       res2 = this.checkChildren(child.children);
  //     } else if (!isNullOrUndefined(child.data.claim) && child.children.length > 0) {
  //       this.roles.forEach(role => {
  //         if (role === child.data.claim) {
  //           res2 = this.checkChildren(child.children);
  //         }
  //       });
  //     } else if (!isNullOrUndefined(child.data.claim) && child.children.length === 0) {
  //       this.roles.forEach(role => {
  //         if (role === child.data.claim) {
  //           res2 = true;
  //         }
  //       });
  //     } else if (isNullOrUndefined(child.data.claim) && child.children.length === 0) {
  //       res2 = true;
  //     }
  //   });
  //   return res2;
  // }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
}
